import React, { Component } from "react";
import { MdExpandMore } from "react-icons/md";
import Moment from "react-moment";

class ListTransactions extends Component {
  render() {
    const { transactions, selectedContent } = this.props;
    return (
      <React.Fragment>
        <div className="container">
          <div className="transaction-content">
            <div
              className="card-panel white lighten-5 z-depth-1"
              style={{
                width: "100%",
                margin: "auto",
                height: "auto",
                display: "block",
                position: "relative",
                boxShadow:
                  "0 2px 5px rgba(0, 0, 0, 0.12), 0 2px 5px rgba(0, 0, 0, 0.24)",
                fontSize: "1.1rem",
                marginTop: "205px"
              }}
            >
              {selectedContent.length > 0 ? (
                selectedContent
                  .filter(
                    selectTransaction =>
                      selectTransaction.status
                        .toLowerCase()
                        .includes("ativa") ||
                      selectTransaction.status
                        .toLowerCase()
                        .includes("pendente") ||
                      selectTransaction.status
                        .toLowerCase()
                        .includes("concluida")
                  )
                  .map((transaction, i) => (
                    <React.Fragment key={i}>
                      <div
                        className="accordion md-accordion accordion-blocks"
                        id="accordionEx78"
                        role="tablist"
                        aria-multiselectable="true"
                        style={{
                          alignContent: "left",
                          backgroundColor: "white",
                          boxShadow:
                            "0 2px 5px rgba(0, 0, 0, 0.12), 0 2px 5px rgba(0, 0, 0, 0.24)",
                          display: "block",
                          margin: "auto"
                        }}
                      >
                        <div className="card white" id={"card" + i}>
                          <div
                            className="card-header"
                            role="tab"
                            id={"headingUnfiled" + i}
                            style={
                              transaction.status.toLowerCase().includes("ativa")
                                ? {
                                    backgroundColor: "#357ae8"
                                  }
                                : transaction.status
                                    .toLowerCase()
                                    .includes("pendente")
                                ? {
                                    backgroundColor: "#ff6347"
                                  }
                                : {
                                    backgroundColor: "#343a40"
                                  }
                            }
                          >
                            <a
                              data-toggle="collapse"
                              data-parent={"#card" + i}
                              href={"#collapseUnfiled" + i}
                              aria-expanded="true"
                              aria-controls="collapseUnfiled"
                            >
                              <h5 className="mt-4 mb-0">
                                <span style={{ color: "white" }}>
                                  Malote
                                  {transaction.status
                                    .toLowerCase()
                                    .includes("ativa") ? (
                                    <i> - Ativo</i>
                                  ) : transaction.status
                                      .toLowerCase()
                                      .includes("pendente") ? (
                                    <i> - Pendente</i>
                                  ) : (
                                    transaction.status
                                      .toLowerCase()
                                      .includes("concluida") && (
                                      <i> - Concluído</i>
                                    )
                                  )}
                                  <p
                                    className="left"
                                    style={{ color: "white" }}
                                  >
                                    ID: {transaction.id_transacao}
                                  </p>
                                  <p
                                    className="right"
                                    style={{ color: "white" }}
                                  >
                                    <MdExpandMore />
                                  </p>
                                </span>
                              </h5>
                            </a>
                          </div>
                          <div
                            id={"collapseUnfiled" + i}
                            className="collapse show"
                            role="tabpanel"
                            aria-labelledby={"headingUnfiled" + i}
                            data-parent={"#card" + i}
                          >
                            <div className="card-body">
                              <React.Fragment>
                                <div
                                  className="row justify-content-center"
                                  style={{
                                    display: "block",
                                    margin: "auto",
                                    width: "100%"
                                  }}
                                >
                                  <div className="col s12">
                                    <table className="table table-adapt table-sm table-hover">
                                      <thead>
                                        <tr>
                                          <th scope="col">Data de Criação</th>
                                          <th scope="col">Horário</th>
                                          <th scope="col">
                                            Data de Modificação
                                          </th>
                                          <th scope="col">Horário</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <td>
                                            <Moment format="DD/MM/YYYY">
                                              {transaction.created_at}
                                            </Moment>
                                          </td>
                                          <td>
                                            <Moment
                                              add={{ hours: 3 }}
                                              format="HH:mm:ss"
                                            >
                                              {transaction.created_at}
                                            </Moment>
                                          </td>
                                          <td>
                                            <Moment format="DD/MM/YYYY">
                                              {transaction.updated_at}
                                            </Moment>
                                          </td>
                                          <td>
                                            <Moment
                                              add={{ hours: 3 }}
                                              format="HH:mm:ss"
                                            >
                                              {transaction.updated_at}
                                            </Moment>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </React.Fragment>
                            </div>
                          </div>
                        </div>
                      </div>
                    </React.Fragment>
                  ))
              ) : selectedContent && transactions.length > 0 ? (
                transactions
                  .filter(
                    selectTransaction =>
                      selectTransaction.status
                        .toLowerCase()
                        .includes("ativa") ||
                      selectTransaction.status
                        .toLowerCase()
                        .includes("pendente") ||
                      selectTransaction.status
                        .toLowerCase()
                        .includes("concluida")
                  )
                  .map((transaction, i) => (
                    <React.Fragment key={i}>
                      <div
                        className="accordion md-accordion accordion-blocks"
                        id="accordionEx78"
                        role="tablist"
                        aria-multiselectable="true"
                        style={{
                          alignContent: "left",
                          boxShadow:
                            "0 2px 5px rgba(0, 0, 0, 0.12), 0 2px 5px rgba(0, 0, 0, 0.24)"
                        }}
                      >
                        <div className="card white" id={"card" + i}>
                          <div
                            className="card-header"
                            role="tab"
                            id={"headingUnfiled" + i}
                            style={
                              transaction.status.toLowerCase().includes("ativa")
                                ? {
                                    backgroundColor: "#357ae8"
                                  }
                                : transaction.status
                                    .toLowerCase()
                                    .includes("pendente")
                                ? {
                                    backgroundColor: "#ff6347"
                                  }
                                : {
                                    backgroundColor: "#343a40"
                                  }
                            }
                          >
                            <a
                              data-toggle="collapse"
                              data-parent={"#card" + i}
                              href={"#collapseUnfiled" + i}
                              aria-expanded="true"
                              aria-controls="collapseUnfiled"
                            >
                              <h5 className="mt-4 mb-0">
                                <span style={{ color: "white" }}>
                                  Malote
                                  {transaction.status
                                    .toLowerCase()
                                    .includes("ativa") ? (
                                    <i> - Ativo</i>
                                  ) : transaction.status
                                      .toLowerCase()
                                      .includes("pendente") ? (
                                    <i> - Pendente</i>
                                  ) : (
                                    transaction.status
                                      .toLowerCase()
                                      .includes("concluida") && (
                                      <i> - Concluído</i>
                                    )
                                  )}
                                  <p
                                    className="left"
                                    style={{ color: "white" }}
                                  >
                                    ID: {transaction.id_transacao}
                                  </p>
                                  <p
                                    className="right"
                                    style={{ color: "white" }}
                                  >
                                    <MdExpandMore />
                                  </p>
                                </span>
                              </h5>
                            </a>
                          </div>
                          <div
                            id={"collapseUnfiled" + i}
                            className="collapse show"
                            role="tabpanel"
                            aria-labelledby={"headingUnfiled" + i}
                            data-parent={"#card" + i}
                          >
                            <div className="card-body">
                              <React.Fragment>
                                <div
                                  className="row justify-content-center"
                                  style={{
                                    display: "block",
                                    margin: "auto",
                                    width: "100%"
                                  }}
                                >
                                  <div className="col s12">
                                    <table className="table table-adapt table-sm table-hover">
                                      <thead>
                                        <tr>
                                          <th scope="col">Data de Criação</th>
                                          <th scope="col">Horário</th>
                                          <th scope="col">
                                            Data de Modificação
                                          </th>
                                          <th scope="col">Horário</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <td>
                                            <Moment format="DD/MM/YYYY">
                                              {transaction.created_at}
                                            </Moment>
                                          </td>
                                          <td>
                                            <Moment
                                              add={{ hours: 3 }}
                                              format="HH:mm:ss"
                                            >
                                              {transaction.created_at}
                                            </Moment>
                                          </td>
                                          <td>
                                            <Moment format="DD/MM/YYYY">
                                              {transaction.updated_at}
                                            </Moment>
                                          </td>
                                          <td>
                                            <Moment
                                              add={{ hours: 3 }}
                                              format="HH:mm:ss"
                                            >
                                              {transaction.updated_at}
                                            </Moment>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </React.Fragment>
                            </div>
                          </div>
                        </div>
                      </div>
                    </React.Fragment>
                  ))
              ) : (
                <p style={{ paddingTop: "25px" }}>
                  Nenhum registro encontrado.
                </p>
              )}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ListTransactions;
